import React from 'react';
import StatusChip from './StatusChip.tsx';

interface DetailShellProps {
  breadcrumb: string;
  title: React.ReactNode;
  subtitle?: string;
  statusLabel?: string;
  statusTone?: 'green' | 'amber' | 'slate' | 'blue' | 'red';
  backLabel: string;
  onBack: () => void;
  actions?: React.ReactNode;
  tabs?: React.ReactNode;
  children: React.ReactNode;
}

/** Chrome de detalhe alinhado a Investimentos / Frota (DS). */
const DetailShell: React.FC<DetailShellProps> = ({
  breadcrumb,
  title,
  subtitle,
  statusLabel,
  statusTone = 'green',
  backLabel,
  onBack,
  actions,
  tabs,
  children,
}) => (
  <div>
    <div className="breadcrumb" style={{ marginBottom: 4 }}>
      {breadcrumb}
    </div>
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 12,
        marginBottom: 8,
      }}
    >
      <div>
        <h1
          className="page-title"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}
        >
          {title}
          {statusLabel ? <StatusChip label={statusLabel} tone={statusTone} /> : null}
        </h1>
        {subtitle ? <div className="page-subtitle">{subtitle}</div> : null}
      </div>
    </div>

    <div className="toolbar" style={{ marginBottom: 12 }}>
      <div className="filters">
        <button type="button" className="btn btn-ghost btn-sm" onClick={onBack}>
          ← {backLabel}
        </button>
      </div>
      {actions ? <div className="detail-actions">{actions}</div> : null}
    </div>

    {tabs}

    {children}
  </div>
);

export default DetailShell;
